// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__283Ew","delete":"styles_delete__3OGI_","update":"styles_update__eFzwU","add":"styles_add__1-aNG"};